import { LinkData } from "@/ui/types/link"
import { LinkField } from "../sanityTypes"
import { buildPageUrl } from "@/root/routing/urls"

export const toLink = (linkField?: LinkField): LinkData | undefined => {
  if (!linkField) {
    return undefined
  }

  switch (linkField.type) {
    case "external":
      return linkField.externalLink ? {
        type: "external",
        url: linkField.externalLink,
        linkTarget: linkField.linkTarget,
      } : undefined
    case "internal":
      return linkField.internalLink ? {
        type: "internal",
        url: buildPageUrl(linkField.internalLink as any),
        linkTarget: linkField.linkTarget,
      } : undefined
    case "anchor":
      return linkField.anchor ? {
        type: "anchor",
        anchor: linkField.anchor,
      } : undefined
  }
}
